import { useFetch } from "../useFetch";
import type {
	NotificationResponse,
	CreateNotificationPayload,
	UpdateNotificationPayload,
} from "../../core/types/services";

// ============================================
// GET ALL NOTIFICATIONS
// ============================================
export function useNotifications() {
	return useFetch<NotificationResponse[]>({
		endpoint: "/notifications",
		method: "GET",
	});
}

// ============================================
// GET NOTIFICATION BY ID
// ============================================
export function useNotification(id: number) {
	return useFetch<NotificationResponse>({
		endpoint: `/notifications/${id}`,
		method: "GET",
	});
}

// ============================================
// GET NOTIFICATIONS BY USER
// ============================================
export function useNotificationsByUser(userId: number) {
	return useFetch<NotificationResponse[]>({
		endpoint: `/notifications/user/${userId}`,
		method: "GET",
	});
}

// ============================================
// GET UNREAD NOTIFICATIONS BY USER (nuevo)
// ============================================
export function useNotificationsByUserUnread(userId: number) {
	return useFetch<NotificationResponse[]>({
		endpoint: `/notifications/user/${userId}/unread`,
		method: "GET",
		auto: userId > 0,
	});
}

// ============================================
// CREATE NOTIFICATION
// ============================================
export function useCreateNotification() {
	const fetch = useFetch<NotificationResponse, CreateNotificationPayload>({
		endpoint: "/notifications",
		method: "POST",
		auto: false,
	});

	const create = (data: CreateNotificationPayload) => {
		return fetch.execute({ body: data });
	};

	return { ...fetch, create };
}

// ============================================
// UPDATE NOTIFICATION (Mark as Read / Edit)
// ============================================
export function useUpdateNotification(id: number) {
	const fetch = useFetch<NotificationResponse, UpdateNotificationPayload>({
		endpoint: `/notifications/${id}`,
		method: "PATCH",
		auto: false,
	});

	const update = (data: UpdateNotificationPayload) => {
		return fetch.execute({ body: data });
	};

	// Helper específico para marcar como leída sin pasar todo el objeto
	const markAsRead = () => {
		return fetch.execute({ body: { is_read: true } });
	};

	return { ...fetch, update, markAsRead };
}

// ============================================
// DELETE NOTIFICATION
// ============================================
export function useDeleteNotification() {
	const fetch = useFetch<{ message: string }>({
		endpoint: "/notifications",
		method: "DELETE",
		auto: false,
	});

	const remove = (id: number) => {
		return fetch.execute({ endpoint: `/notifications/${id}` });
	};

	return { ...fetch, remove };
}
